import { Alert, Box } from '@ksyos/design-system';
import { useLocation } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { fetchJson } from '../../store/fetch';
import { translateKey } from '../../translate';

interface IExactAuthenticationProps {
    updateExactAllowsAction: (value: boolean) => Promise<void> | void;
}

export function ExactAuthentication(props: IExactAuthenticationProps) {
    const { pathname } = useLocation();
    const [exactCredentialsMissing, setExactCredentialsMissing] = useState<boolean>();
    const [exactSessionExists, setExactSessionExists] = useState<boolean>(false);
    const [exactUrl, setExactUrl] = useState<string>();

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        props.updateExactAllowsAction(exactSessionExists || !!exactCredentialsMissing);
    }, [exactCredentialsMissing, exactSessionExists]);

    return (
        <>
            {exactSessionExists && (
                <Alert appearance="info">
                    <Box
                        alignItems="center"
                        display="flex"
                        justifyContent="space-between"
                    >
                        <Alert.Text
                            as="p"
                            fontWeight="bold"
                        >
                            {translateKey('exact.integrationWorking')}
                        </Alert.Text>
                        <Alert.Button onClick={handleLogoutFromExact}>{translateKey('exact.logout')}</Alert.Button>
                    </Box>
                </Alert>
            )}
            {exactSessionExists === false && !exactCredentialsMissing && (
                <Alert appearance="warning">
                    <Alert.Link
                        onClick={async () => await handleRedirect()}
                        variant="button"
                    >
                        {translateKey('exact.logInToExport')}
                    </Alert.Link>{' '}
                    {translateKey('exact.onlyTrialExportAllowed')}
                </Alert>
            )}
            {exactCredentialsMissing && <Alert appearance="warning">{translateKey('exact.credentialsMissing')}</Alert>}
        </>
    );

    async function load() {
        let result = await fetchJson('/api/exact/userHasAccessToken', 'GET');
        setExactSessionExists(result.json.userHasAccessToken);

        result = await fetchJson('/api/exact/getAuthenticationLink', 'GET');
        if (result.json.clientId) {
            setExactUrl(
                `${result.json.exactBaseUrl}/api/oauth2/auth?client_id=${result.json.clientId}&redirect_uri=${result.json.redirectUrl}&response_type=code&force_login=0`
            );
        } else {
            setExactCredentialsMissing(true);
        }
    }

    async function handleRedirect() {
        localStorage.setItem('exactRedirectionUrl', pathname);
        window.open(exactUrl ?? '/', '_self');
    }

    async function handleLogoutFromExact() {
        await fetchJson('/api/exact/logout', 'POST');

        setExactSessionExists(false);
    }
}
